// src/pages/Dashboard.jsx
import React from 'react';
import { Card, Typography, Space } from 'antd';
import { useAuth } from '../context/AuthContext';

const { Title, Text } = Typography;

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div style={{ padding: '40px', maxWidth: 1000, margin: '0 auto' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={2}>企業管理系統</Title>
          
          <Text strong>目前登入使用者：</Text>
          <Text style={{ fontSize: 18 }}>
            {user?.name || user?.username || user?.sub || '未知使用者'}
          </Text>

          {user?.role && (
            <Text type="secondary">角色：{user.role}</Text>
          )}

          <Text type="success" style={{ fontSize: 16 }}>
            登入成功！現在可以開始開發其他功能囉
          </Text>
        </Space>
      </Card>
    </div>
  );
};

export default Dashboard;